// extracted by mini-css-extract-plugin
export default {"leftRight":"leftRight___NS1vU","Slider":"Slider___W4G3V","rightContent":"rightContent___rFZRI","rightContent_inner":"rightContent_inner___f6S0Q"};